// extracted by mini-css-extract-plugin
export var active = "mainnav-item-module--active--T3T+E";
export var leftIcon = "mainnav-item-module--leftIcon--9zNgR";
export var mainNavItem = "mainnav-item-module--mainNavItem--xWYZx";
export var rightIcon = "mainnav-item-module--rightIcon--hEhCi";
export var saturate = "mainnav-item-module--saturate--Tp4tp";
export var tab = "mainnav-item-module--tab--E4Csw";